import(/* webpackMode: "eager", webpackExports: ["App"] */ "/app/apps/webapp/app/components/App.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/webapp/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalToastMessageProvider"] */ "/app/apps/webapp/libs/callabo-ui/contexts/GlobalToastMessageContext.tsx");
